// extracted by mini-css-extract-plugin
export var button = "_cg-0";
export var icon = "_cg-1";